// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__bNCKr","list":"styles_list__TmfD1","vertical":"styles_vertical__5sG4e"};